import { useEffect, useState } from 'react';
import {
  fetchPainMapGenderFromMedicalRecords,
  inferPainMapGenderFromName,
  resolvePainMapGender,
} from '../utils/patientGender';

export default function usePainMapGender(emiratesId, patientName) {
  const [gender, setGender] = useState(() => inferPainMapGenderFromName(patientName) || 'man');
  const [userOverride, setUserOverride] = useState(false);

  useEffect(() => {
    setUserOverride(false);
    setGender(inferPainMapGenderFromName(patientName) || 'man');
  }, [emiratesId, patientName]);

  useEffect(() => {
    if (!emiratesId || userOverride) {
      return undefined;
    }

    let cancelled = false;

    const loadGender = async () => {
      const medicalGender = await fetchPainMapGenderFromMedicalRecords(emiratesId);
      if (cancelled || userOverride) {
        return;
      }

      setGender(
        resolvePainMapGender({
          medicalGender,
          patientName,
        })
      );
    };

    loadGender();

    return () => {
      cancelled = true;
    };
  }, [emiratesId, patientName, userOverride]);

  const setGenderWithOverride = (nextGender) => {
    if (!nextGender) {
      return;
    }
    setUserOverride(true);
    setGender(nextGender);
  };

  return [gender, setGenderWithOverride];
}
